// extracted by mini-css-extract-plugin
module.exports = {"status":"subscription-status_status__x8H2M","statusLabel":"subscription-status_statusLabel__1O-vS"};